import React from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../components/DashboardLayout";
import { XCircle, ArrowLeft } from "lucide-react";
import { useT } from "../lib/i18n";

export default function BillingCancel() {
  const { t } = useT();
  const navigate = useNavigate();
  return (
    <DashboardLayout title={t("Payment cancelled")}>
      <div className="max-w-2xl mx-auto">
        <div data-testid="billing-cancel" className="bg-white border border-slate-200 rounded-xl p-10 text-center">
          <div className="mx-auto w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center">
            <XCircle className="w-9 h-9 text-[#475569]" />
          </div>
          <h2 className="font-display font-black text-3xl text-[#0B1B3D] mt-6">{t("Payment cancelled")}</h2>
          <p className="text-sm text-[#475569] mt-2">
            {t("No charge was made. You can pick a different credit pack or come back later.")}
          </p>
          <div className="mt-8 flex items-center justify-center gap-3">
            <button
              data-testid="cancel-back-to-billing"
              onClick={() => navigate("/billing")}
              className="bg-[#0B1B3D] text-white hover:bg-[#1E3A8A] px-5 py-2.5 rounded-lg font-bold text-sm font-display inline-flex items-center gap-2"
            >
              <ArrowLeft className="w-4 h-4" /> {t("Back to billing")}
            </button>
            <button
              onClick={() => navigate("/dashboard")}
              className="border border-slate-300 text-[#0B1B3D] hover:bg-slate-50 px-5 py-2.5 rounded-lg font-bold text-sm font-display"
            >
              {t("Go to dashboard")}
            </button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
